
// For ajax Cart Drawer
const openCartDrawer = (event) => {
    event.preventDefault();
    var loadAjax = event.currentTarget.dataset.loadAjax;
    window.ajaxDrawer.init(loadAjax,true);
  }
  
  document.querySelector("#cart-icon-bubble").addEventListener("click", openCartDrawer.bind(this));
  
  window.ajaxDrawer = {
    init: function(loadAjax,openDrawer = false) {
      ajaxDrawer.openDrawer = openDrawer;
      ajaxDrawer.onLoadAddListeners();
      (loadAjax == "true") ? this.getCartData() : false;
    },
    onLoadAddListeners:function(){
      if(ajaxDrawer.openDrawer == true){
        ajaxDrawer.addDrawerClass();
      }
      ajaxDrawer.closeDrawerEvent();
      ajaxDrawer.removeItemFromCart();
    },
    getCartData: function() {
      if(ajaxDrawer.openDrawer == true){
        ajaxDrawer.addDrawerClass();
      }
      // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'block';
      
      var $this = this;
      fetch('/cart').then(function(response) {
        // The API call was successful!
        return response.text();
      }).then(function(html) {
        document.getElementById('cart-icon-bubble').setAttribute('data-load-ajax',"false");
        // document.querySelector('[loading-for-quickview]').style.display = 'none';
        // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'none';
        // This is the HTML from our response as a text string
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html'),
            htmlData = doc.querySelector('[data-items-wrapper]').innerHTML,
            totalQuantity = doc.querySelector('[data-items-wrapper]').dataset.totalitems;
        document.querySelector(".cartBubbleCount").innerText = totalQuantity;
        
        
        if(document.body.classList.contains('template-cart')){
          var itemCount = doc.querySelector('#main-cart-items').dataset.itemCount;
          if(itemCount == "0"){
            document.querySelector('.cart_wrapper').classList.add('is-empty');
          }
          document.querySelector('#main-cart-items .js-contents').innerHTML = doc.querySelector('#main-cart-items .js-contents').innerHTML;
          document.querySelector('#main-cart-footer').innerHTML = doc.querySelector('#main-cart-footer').innerHTML;
          new CartItems();
        }
        
        
        $this.addDataInDrawer(htmlData);
      }).catch(function(err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });
    },
    addDataInDrawer: function(data) {
      document.getElementById("dropdown-cart").querySelector('[data-cart-items]').innerHTML = data;
  //     this.addDrawerClass();
      this.closeDrawerEvent();
      this.removeItemFromCart();
  
      addGiftProduct.init(document.querySelector('[data-cart-items]'),true);
    },
    removeDrawerClass: function() {
      document.body.classList.remove("cart-drawer-open");
    },
    addDrawerClass: function() {
      document.body.classList.add("cart-drawer-open");
    },
    closeDrawerEvent: function() {
      var $this = this;
      document.querySelector(".cartDrawer-close--btn").addEventListener("click", function() {
        $this.removeDrawerClass();
      });
      document.querySelector(".drawer-overlay").addEventListener("click", function() {
        $this.removeDrawerClass();
      });
    },
    removeItemFromCart: function() {
      var $this = this;
      document.querySelectorAll(".item--btn-remove").forEach(function(evt) {
        evt.addEventListener("click", function() {
          var variantId = this.dataset.variantid,
              quantity = this.dataset.quentity;
          var item = {
            id: variantId,
            quantity: 0
          }
          $this.changeQuantity(item)
        });
      })
    },
    changeQuantity: function(item) {
      var $this = this;
      // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'block';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      }).then((res) => { return res.json() })
      .then((response) => {
        $this.getCartData();
      })
      .catch((error) => {
        console.error('Error:', error);
        return false;
      });
    }
  
  }